import {store} from '../../../app/store'
import Brands from '../../brand/brand'
import CustomerTypes, {
    CustomerTypesUrl,
} from '../../customerTypes/customerTypes'

export default function getPageName(carSlug: string, isSingle = true): string {
    const brandFromStore = store.getState().general.brand
    let currentCustomerTypeUrl = ''
    let customerType = CustomerTypesUrl.PR

    if (brandFromStore === Brands.VIC) {
        currentCustomerTypeUrl = store.getState().general.customerType
        customerType =
            currentCustomerTypeUrl === CustomerTypes.PRIVATE
                ? CustomerTypesUrl.PR
                : CustomerTypesUrl.BU
    }

    if (isSingle) {
        if (brandFromStore === Brands.VIC) {
            return `app : promozioni : tipologia : ${customerType} : model : ${carSlug}`
        }

        return `app : promozioni : model : ${carSlug}`
    }

    if (brandFromStore === Brands.VIC) {
        return `app : promozioni : tipologia : ${customerType}`
    }

    return 'app : promozioni'
}
